import { NavLink, Link } from "react-router-dom";

function IconDashboard() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <rect x="3" y="3" width="7" height="7" rx="1" />
         <rect x="14" y="3" width="7" height="7" rx="1" />
         <rect x="3" y="14" width="7" height="7" rx="1" />
         <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
   );
}

function IconVisitors() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <circle cx="9" cy="8" r="3" />
         <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" strokeLinecap="round" />
         <circle cx="17" cy="9" r="2.5" />
         <path d="M14 20c.3-2.2 1.8-4 4-4" strokeLinecap="round" />
      </svg>
   );
}

function IconMessages() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <path d="M4 6h16v10H7l-3 3V6z" strokeLinejoin="round" />
      </svg>
   );
}

function IconPortfolio() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <rect x="3" y="7" width="18" height="13" rx="2" />
         <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg>
   );
}

function IconProfile() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <circle cx="12" cy="8" r="4" />
         <path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" strokeLinecap="round" />
      </svg>
   );
}

function IconSettings() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <circle cx="12" cy="12" r="3" />
         <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
   );
}

function IconWand() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <path d="M15 4l1 1M4 15l10-10M9 3l1 1M3 9l1 1M19 13l1 1M13 19l1 1M21 21l-2-2" strokeLinecap="round" />
      </svg>
   );
}

const NAV_ITEMS = [
   { to: "/dashboard", label: "Dashboard", icon: IconDashboard, end: true, disabled: true },
   { to: "/dashboard", label: "Visitors", icon: IconVisitors, end: true },
   { to: "#messages", label: "Messages", icon: IconMessages, disabled: true },
   { to: "/", label: "Portfolio", icon: IconPortfolio, external: true },
   { to: "/dashboard/profile", label: "Profile", icon: IconProfile },
   { to: "#settings", label: "Settings", icon: IconSettings, disabled: true },
];

function AdminSidebar() {
   const linkClass = ({ isActive }) =>
      `admin-sidebar__link${isActive ? " admin-sidebar__link--active" : ""}`;

   return (
      <aside className="admin-sidebar" aria-label="Admin navigation">
         <Link to="/dashboard" className="admin-sidebar__brand">
            <span className="admin-sidebar__brand-mark" aria-hidden>
               P
            </span>
            <span>Portfolio admin</span>
         </Link>

         <nav className="admin-sidebar__nav">
            <ul className="admin-sidebar__list">
               {NAV_ITEMS.map((item) => {
                  const Icon = item.icon;
                  if (item.disabled) {
                     return (
                        <li key={item.label}>
                           <span className="admin-sidebar__link admin-sidebar__link--disabled">
                              <Icon />
                              {item.label}
                           </span>
                        </li>
                     );
                  }
                  if (item.external) {
                     return (
                        <li key={item.label}>
                           <a
                              className="admin-sidebar__link"
                              href={item.to}
                              target="_blank"
                              rel="noreferrer noopener"
                           >
                              <Icon />
                              {item.label}
                           </a>
                        </li>
                     );
                  }
                  return (
                     <li key={item.label}>
                        <NavLink to={item.to} end={item.end} className={linkClass}>
                           <Icon />
                           {item.label}
                        </NavLink>
                     </li>
                  );
               })}
            </ul>
         </nav>

         <div className="admin-sidebar__upgrade">
            <span className="admin-sidebar__upgrade-icon" aria-hidden>
               <IconWand />
            </span>
            <p className="admin-sidebar__upgrade-title">Upgrade to Pro</p>
            <p className="admin-sidebar__upgrade-desc">
               Unlock advanced analytics and export tools.
            </p>
            <button type="button" className="admin-sidebar__upgrade-btn" disabled>
               Upgrade Now
            </button>
         </div>
      </aside>
   );
}

export default AdminSidebar;
